
    <wms-dialog-header (onClose)="deployService.closeDeployDialog()" [title]="dialogTitle" [helpTitle]="dialogTitle"
        [showClose]="false"></wms-dialog-header>
    <wms-dialog-body>
        <div class="left-container full-height">
            <div class="top-asset">
                <i class="cloud-icon"
                    [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/cloud.png)'}"></i>
                <i *ngIf="deployService.deploying?.error" class="face-icon"
                    [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/face.png)'}"></i>
                <div *ngIf="deployService.provisioning?.loading && !deployService.deploying?.error && !deployService?.deployFinished"
                    class="logo-spinner"><i class="spinner"></i><i class="wms wms-logo"></i></div>
                <i *ngIf="deployService.deploying?.success" class="wms-icon wms-about-logo wavemaker-icon"></i>
            </div>
            <div class="middle-asset">
                <div class="static"
                    *ngIf="(deployService.deploying?.success || deployService.deploying?.error) && deployService.deployFinished">
                    <i class="line line-1"
                        [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/line-1.png)'}"></i>
                    <p class="loader">
                        <span>.</span><span>.</span><span>.</span><span>.</span><span>.</span><span>.</span>
                    </p>
                    <i class="line line-2"
                        [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/line-2.png)'}"></i>
                </div>
                <div class="marquee-loading"
                    *ngIf="deployService.provisioning?.loading && !deployService.deploying?.error && !deployService.deployFinished">
                    <marquee class="line-marquee" direction="UP" scrollamount="18"><i class="line"
                            [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/line-1.png)'}"></i>
                    </marquee>
                    <p class="loader">
                        <span>.</span><span>.</span><span>.</span><span>.</span><span>.</span><span>.</span>
                    </p>
                    <marquee class="line-marquee" direction="UP" scrollamount="18"><i class="line"
                            [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/line-2.png)'}"></i>
                    </marquee>
                </div>
            </div>
            <div class="bottom-asset">
                <i
                    [ngStyle]="{backgroundImage: 'url('+baseURL+'/images/deploy/device.png)'}"></i>
            </div>
        </div>
        <div class="right-container full-height">
            <div class="features full-height">
                <div class="features-status">
                    <wms-message *ngIf="deployService.msgData.show" hideclose="true"
                        [scopeDataset]="deployService.msgData"></wms-message>
                    <div class="status">
                        <p class="step"
                            [ngClass]="{'success': deployService.inspectionState===deployService.INSP_SUCC, 'loading': deployService.inspectionState===deployService.INSP_RUN, 'error': deployService.inspectionState===deployService.INSP_ERR, 'warning':deployService.inspectionState===deployService.INSP_WARN}">
                            <span class="step"><span class="step-text">1</span><i class="wms"
                                    [ngClass]="{'wms-done-bold': deployService.inspectionState===deployService.INSP_SUCC , 'wms-error-bold': deployService.inspectionState===deployService.INSP_ERR, 'wms-warning-bold': deployService.inspectionState===deployService.INSP_WARN}"></i></span>
                            <span>{{getInspectionDialogTxt()}}</span>
                            <br />
                            <span
                                *ngIf="deployService.inspectionState===deployService.INSP_ERR || deployService.inspectionState===deployService.INSP_WARN"
                                class="step-action"
                                (click)="deployService.checkInspectErrors()">{{locale.LABEL_DEPLOY_CHECK_INSPECT_RESULT}}</span>
                        </p>
                        <p class="step"
                            [ngClass]="{'success': deployService.getCurrentStep()>0 || deployService.deploying?.success, 'loading': (deployService.inspectionState===deployService.INSP_WARN || deployService.inspectionState===deployService.INSP_SUCC) && deployService.currentDeployStep===0 && !deployService.deploying?.error && !deployService.deploying?.success, 'error': (deployService.inspectionState===deployService.INSP_WARN || deployService.inspectionState===deployService.INSP_SUCC) && deployService.currentDeployStep===0 && deployService.deploying?.error}">
                            <span class="step"><span class="step-text">2</span><i class="wms"
                                    [ngClass]="{'wms-done-bold': (deployService.getCurrentStep()>0 || deployService.deploying?.success), 'wms-error-bold': deployService.currentDeployStep===0 && deployService.deploying?.error}"></i></span>
                            <span>{{locale.LABEL_DEPLOY_PROGRESS_STEP_1}}</span>
                        </p>
                        <p class="step"
                            [ngClass]="{'success': deployService.getCurrentStep()>4 || deployService.deploying?.success, 'loading': (deployService.getCurrentStep()>1 && deployService.getCurrentStep()<5) && !deployService.deploying?.error && !deployService.deploying?.success, 'error': (deployService.getCurrentStep()>1 && deployService.getCurrentStep()<5) && deployService.deploying?.error}">
                            <span class="step"><span class="step-text">3</span><i class="wms"
                                    [ngClass]="{'wms-done-bold': (deployService.getCurrentStep()>4 || deployService.deploying?.success), 'wms-error-bold': (deployService.getCurrentStep()>1 && deployService.getCurrentStep()<5) && deployService.deploying?.error}"></i></span>
                            <span>{{locale.LABEL_DEPLOY_PROGRESS_STEP_2}}</span>
                        </p>
                        <p class="step last-step"
                            [ngClass]="{'success': deployService.deploying?.success, 'error': deployService.deploying?.error}">
                            <span class="step"><span class="step-text">4</span><i class="wms"
                                    [ngClass]="{'wms-done-bold': deployService.deploying?.success, 'wms-error-bold': deployService.deploying?.error}"></i></span>
                            <span>{{locale.LABEL_DEPLOY_PROGRESS_STEP_3}}</span><br /><span
                                class="text-muted project-name">{{projectName}}</span>
                        </p>
                    </div>
                </div>
                <div class="manage-applications">
                    <div class="deploy-url">
                        <a name="wm-deployed-apps" target="_blank" *ngIf="deployService.showManageAppBtn"
                            [href]="manageDeployedAppsUrl"
                            class="btn btn-default button-secondary">{{locale.LABEL_MANAGE_APPLICATIONS}}</a>
                        <a [ngClass]="{'disabled' : !deployService.deploying?.success}"
                            class="btn btn-default button-secondary" name="wm-deployed-application" target="_blank"
                            [href]="deployService.deployedAppUrl">
                            {{locale.LABEL_LAUNCH_APPLICATION}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </wms-dialog-body>
    <wms-dialog-footer>
        <button name="wm-deploy-close" class="btn btn-default button-primary" title="close"
            (click)="deployService.inspectionState===deployService.INSP_ERR?deployService.checkInspectErrors():deployService.closeDeployDialog()">{{getActionButtonTxt()}}</button>
    </wms-dialog-footer>
